import { render, staticRenderFns } from "./BranchMenu.vue?vue&type=template&id=4b772e90&scoped=true&"
import script from "./BranchMenu.vue?vue&type=script&lang=ts&"
export * from "./BranchMenu.vue?vue&type=script&lang=ts&"
import style0 from "./BranchMenu.vue?vue&type=style&index=0&id=4b772e90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b772e90",
  null
  
)

export default component.exports